import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';

export default function LatestUpdateSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-14 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 font-bold">
              最新更新
            </h2>
            <p className="mt-2 text-sm text-foreground-500 font-label">
              每日新鲜章节，精彩不容错过
            </p>
          </div>
          <div className="text-sm text-foreground-500 max-w-md leading-relaxed">
            89890漫画网每日更新最新漫画章节，涵盖<strong>恋爱</strong>、<strong>校园</strong>、<strong>奇幻</strong>等热门题材，保持追更不落队
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {latestUpdates.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              data-product-shop=""
            >
              <div className="relative overflow-hidden" style={{ aspectRatio: '16/10' }}>
                <img
                  src={comic.coverImage}
                  alt={`${comic.title} - 最新漫画更新`}
                  title={`${comic.title}最新章节免费阅读`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-semibold bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
                    {comic.category}
                  </span>
                </div>
              </div>

              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading text-foreground-900 font-bold group-hover:text-primary-500 transition-colors line-clamp-1">
                  {comic.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {comic.description}
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-star-fill text-accent-400"></i>
                      {comic.rating}
                    </span>
                    <span>{comic.author}</span>
                  </div>
                  <span className="text-xs text-primary-500 font-medium flex items-center gap-1 whitespace-nowrap">
                    最新: {comic.chapters[comic.chapters.length - 1]?.title}
                    <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/lianai"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-primary-500 border border-primary-300 rounded-full hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}